<template>
  <div class="create">
    <el-steps
      :active="active"
      align-center
    >
      <el-step title="手机号码" />
      <el-step title="完善账户" />
      <el-step title="权限分配" />
    </el-steps>
    <div class="form-panel">
      <createStep1Form
        v-if="active === 1"
        @next="next1"
      />
      <createStep2Form
        v-if="active === 2"
        :info="stpe1Data"
        :form="stpe2Data"
        @prev="prev"
        @next="next2"
      />
      <createStep3Form
        v-if="active === 3"
        :info="stpe1Data"
        @prev="prev"
        @next="next3"
      />
    </div>
  </div>
</template>
<script>

import axClient from '@/services';
import { mapGetters } from 'vuex';
import createStep1Form from './form/creatStep1.vue';
import createStep2Form from './form/creatStep2.vue';
import createStep3Form from './form/creatStep3.vue';

export default {
  name: 'CaseEdit',
  components: {
    createStep1Form,
    createStep2Form,
    createStep3Form,
  },
  data() {
    return {
      active: 1,
      stpe1Data: {},
      stpe2Data: {},
      stpe3Data: {},
      isEditType: !!this.$route.params.id,
      data: {},
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  mounted() {
    this.isEdit();
  },
  methods: {
    prev(active) {
      this.active = active;
    },

    // 第一步
    next1(data) {
      this.stpe1Data = data;
      this.active = 2;
    },
    // 第二步
    next2(data) {
      this.stpe2Data = data;
      console.log(this.stpe2Data);
      this.active = 3;
    },
    // 第三步
    next3(data) {
      this.stpe3Data = data;
      this.submit();
    },
    // 提交
    async submit() {
      const { id } = this.stpe1Data;
      const {
        loginName, realName, identityType, identityValid, identityRemark, teacherIntro,
        teacherIsShowMp,
        teacherDesc,
        teacherPic,
        teacherAuditCourseList,
      } = this.stpe2Data;
      const data = await axClient.account.upsertBackendUser({
        userId: id,
        identityId: this.data.identityId,
        loginName,
        realName,
        identityType,
        identityValid,
        identityRemark,
        teacherIntro,
        teacherIsShowMp,
        teacherDesc,
        teacherPic,
        permissionList: this.stpe3Data,
        teacherAuditCourseList: teacherAuditCourseList.map((v) => ({ courseClassId: v })),
      });
      if (data) {
        if (this.isEditType) {
          this.$message.success('编辑用户成功');
          if (this.user.id === id) {
            // 编辑的是自己
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.reload();
          }
        } else {
          this.$message.success('新增用户成功');
        }
        this.$router.push({ name: 'AccountList' });
      }
    },
    // 是否编辑信息
    async isEdit() {
      if (this.isEditType) {
        // 编辑
        this.data = await axClient.account.getInfo(this.$route.params.id);
        const {
          mobilePhone, userId, wechatAvatarUrl, wechatNickName,
          loginName, realName, teacherIntro, teacherIsShowMp, identityType,
          identityValid, identityRemark,
          teacherDesc,
          teacherPic,
          teacherAuditCourseList,
        } = this.data;
        this.stpe1Data = {
          id: userId,
          mobilePhone,
          wechatAvatarUrl,
          wechatNickName,
        };
        this.stpe2Data = {
          loginName,
          realName,
          teacherIntro,
          teacherIsShowMp,
          identityType,
          identityValid,
          identityRemark,
          teacherDesc,
          teacherPic,
          teacherAuditCourseList: teacherAuditCourseList.map((v) => v.courseClassId),
        };
        this.active = 2;
      }
    },
  },
};
</script>